import yup from "yup";
import { regexps } from "@bonliva-crm/common";
import {
  AccommodationInput,
  AccommodationType,
  AccommodationPriceType,
  AccommodationOfferInput,
  AddressInput
} from "@graphql";
import locale from "@bonliva-crm/locale";
import { initAddress } from "@consultants/ConsultantBookingContract/utils";

export type FormData = Omit<AccommodationInput, "ResponsiblePersonRef"> & {
  ResponsiblePersonRef?: string;
  _id?: string;
  ImgUrl?: string;
};

export const oneOffer: AccommodationOfferInput = {
  Price: 0,
  Rooms: 0,
  Beds: 0,
  Area: 0,
  PriceType: AccommodationPriceType.PerNight,
  Name: "",
  Options: []
};

export const initialValues: FormData = {
  Type: null,
  Name: "",
  Site: "",
  ImgUrl: "",
  Email: [],
  Phone: [],
  Address: initAddress,
  CheckIn: "",
  CheckOut: "",
  Instruction: "",
  CancellationPolicy: "",
  ResponsiblePersonRef: "",
  preferredChoice: false,
  envCertification: false,
  envCertificationName: "",
  Offers: [oneOffer]
};

export const schema = yup.object<FormData>({
  Address: yup
    .object<AddressInput>()
    .shape({
      City: yup.string().required(locale.fieldIsMandatory(locale.City)),
      Country: yup.string().required(locale.fieldIsMandatory(locale.Country)),
      StreetName: yup.string().required(locale.fieldIsMandatory(locale.StreetName)),
      ZipCode: yup.string().matches(regexps.zipCodeOrEmpty, "Wrong zip code")
    })
    .nullable(true)
    .required(locale.fieldIsMandatory(locale.Address)),
  Name: yup.string().required(locale.fieldIsMandatory(locale.Name)),
  Site: yup.string().nullable(true),
  CancellationPolicy: yup.string().nullable(true),
  Instruction: yup.string().nullable(true),
  Email: yup.array().of(yup.string()),
  Phone: yup.array().of(yup.string()),
  Offers: yup.array().of(
    yup.object<AccommodationOfferInput>().shape({
      Name: yup.string().required(locale.fieldIsMandatory(locale.Name)),
      Price: yup.number().required(locale.fieldIsMandatory(locale.Price)),
      PriceType: yup
        .string()
        .oneOf(
          Object.values(AccommodationPriceType)
        ) as yup.Schema<AccommodationPriceType>,
      Rooms: yup.number().required(locale.fieldIsMandatory(locale.Rooms)),
      Beds: yup.number().required(locale.fieldIsMandatory(locale.Rooms)),
      Area: yup.number().required(locale.fieldIsMandatory(locale.Area)),
      Options: yup.array().of(yup.string())
    })
  ),
  ResponsiblePersonRef: yup.string(),
  preferredChoice: yup.boolean().nullable(true),
  envCertification: yup.boolean().nullable(true),
  envCertificationName: yup.string().nullable(true),
  Type: yup
    .string()
    .nullable(true)
    .oneOf(
      Object.values(AccommodationType),
      locale.fieldIsMandatory(locale.AccommodationType)
    ) as yup.Schema<AccommodationType>
});
